import React from 'react';
import './CenterStage.css'
import SectionHeader from '../SectionHeader/SectionHeader';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CenterStage = ({ imageSrc, title, paragraph, buttonName, buttonLink, imageStyle }) => {
  const { t } = useTranslation();
  const defaultImageStyle = {
    width: '100%', // Set width to fill container
    height: '500px', // Default height
    objectFit: 'cover', // Crop the image to cover the entire container
    padding: '0px'
  };

  const mergedImageStyle = {
    ...defaultImageStyle,
    ...(imageStyle || {})
  };

  const renderButton = () => {
    if (!buttonName || !buttonLink) return null;

    // Check if the link is external (starts with http or https)
    const isExternal = buttonLink.startsWith('http') || buttonLink.startsWith('https');
    // Check if the link is a PDF
    const isPDF = buttonLink.toLowerCase().endsWith('.pdf');

    if (isExternal || isPDF) {
      return (
        <a
          href={buttonLink}
          target="_blank"
          rel="noopener noreferrer"
          className="ImageText-button"
        >
          {t(buttonName)}
        </a>
      );
    }

    // Internal link using React Router
    return (
      <Link to={buttonLink} className="ImageText-button">
        {t(buttonName)}
      </Link>
    );
  };

  const stageTextContainerStyle = {
    width: '70%',
    margin: '0 15%',
  };

  return (
    <div className="stage-container">
      <div className="stage-image-container">
        <img
          className='img-center-stage'
          src={imageSrc}
          alt="Title"
          style={mergedImageStyle}
        />
      </div>

      <div className="stage-text-container">
        <SectionHeader title={title} subtitle={paragraph} />
        <div className='text-center' style={{ marginBottom: '30px' }}>
          {renderButton()}
        </div>
      </div>
    </div>
  );
};

export default CenterStage;
